import React from 'react';

import { Card, CardTitle } from 'material-ui/Card';
import DetailView from '../Common/DetailView';


const Label = (props) => (
    <DetailView title="Label">
        <Card className="cent-card">
            <CardTitle title="Label" />
            </Card>
    </DetailView>
);

export default Label;
